module.exports = __webpack_public_path__ + "img/Ale-Ivanova.0f6fffdd.png";